export const COLOR = '#333';
export const TEXT_COLOR = '#333';
export const SELECTED_TEXT_COLOR = '#eee';
